// ─── El orden de los cursos dentro de un período ────────────────────────────
//
// `recommendedCourseIds` es una LISTA ORDENADA y ese orden se lee en todas
// partes: la vista malla, la escalera, las filas de la auditoría CAP y los
// anexos 2 y 4 que recibe TMAI. En SEBEX representa las tres columnas de cada
// año del documento oficial.
//
// Hasta acá el único orden posible era el de incorporación —el selector agrega
// al final— así que mover una materia obligaba a borrar el año entero y volver a
// armarlo. Un académico lee la malla para entender el programa Y para saber en
// qué orden se dictan las materias; el orden es contenido, no presentación.

/** Mueve el curso de `index` `delta` posiciones. Devuelve la MISMA lista si el
 *  movimiento se sale de los extremos: un botón que no puede hacer nada no debe
 *  inventar un cambio (ni marcar el formulario como sucio). */
export function moveCourse(ids: readonly string[], index: number, delta: number): string[] {
  const target = index + delta;
  if (index < 0 || index >= ids.length || target < 0 || target >= ids.length) return [...ids];
  const next = [...ids];
  const [moved] = next.splice(index, 1);
  next.splice(target, 0, moved!);
  return next;
}

export const canMove = (ids: readonly string[], index: number, delta: number): boolean =>
  index + delta >= 0 && index + delta < ids.length;
